import React from 'react'
import PropTypes from 'prop-types'

// TODO: make generic component for empty states and use it in other places
function NoRows({ message }) {
  return (
    <div style={{
      textAlign: 'left',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      padding: '18px 0px 18px 14px',
    }}
    >
      <p>{message}</p>
    </div>
  )
}

NoRows.propTypes = {
  message: PropTypes.string.isRequired,
}

export default NoRows
